<template>
  <transition name="fade">
    <div class="connact-us-box" v-if="show">
      <div class="w-bx">
        <div class="c-bx">
          <div>
            <h1 class="title">CONTACT US</h1>
            <span class="line2"></span>
            <p class="text">Thank you for your interest in meShare! We'd love to help</p>
            <div>
              <p class="l-tx"><span class="cr"></span> <span class="wr">Provide the adaptable solution for you</span></p>
              <p class="l-tx"><span class="cr"></span> <span class="wr">Explain and deep discuss options for pricing</span></p>
              <p class="l-tx"><span class="cr"></span> <span class="wr">Offer multiple resources to you</span></p>
              <p class="l-tx"><span class="cr"></span> <span class="wr">Give support to customers or users</span></p>
            </div>
            <div class="link-list">
              <p class="r-tx"><span class="rs">Business:</span> partnerships@meshare.com</p>
              <p class="r-tx"><span class="rs">Media:</span> media@meshare.com</p>
              <p class="r-tx"><span class="rs">Customer:</span> support@meshare.com</p>
            </div>
          </div>
          <span class="btnv2-close" @click="closePup()">
            <img src="/static/images/pup/btn-close-1.png" alt="">
          </span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import {WOW} from 'wowjs'
export default {
  name: 'connact-us',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // this.show = false
  },
  methods:{
    closePup(){
      this.$emit("changeShowStatus", false)
    }

  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.connact-us-box{
  .w-bx{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    background-color: rgba(0,0,0,.5);
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-height: 450px) and (orientation : landscape){
      align-items: flex-start;
    }
  }
  .c-bx{
    position: relative;
    width: 90%;
    max-width: 850px;
    min-height: 520px;
    background-color: #FFFFFf;
    background: url(/static/images/pup/bg-1.jpg), url(/static/images/pup/bg-2.jpg), url(/static/images/pup/bg-3.jpg), url(/static/images/pup/bg-4.jpg);
    background-repeat: no-repeat;
    background-position: left top, left bottom, right bottom, right top;
    background-color: #FFFFFf;
    box-sizing: border-box;
    @media screen and (max-width:$media-max-width){
      min-height: 350px;
      background-size: 12vw auto, 23.7vw auto, 14.6vw auto, 42vw auto;
    }
    &>div{
      position: relative;
      box-sizing: border-box;
      padding: 60px 12% 60px;
      @media screen and (max-width:$media-max-width){
        padding: 35px 7.5%;
      }
    }
  }
  .title{
    font-size: 44px;
    font-family: 'GothamMedium';
    color: #333333;
    text-align: center;
    @media screen and (max-width:$media-max-width){
      font-size: calc(10px + 4vw);
    }
  }
  .text{
    color: #333333;
    font-size: 22px;
    font-family: 'GothamMedium';
    margin-bottom: 15px;
    @media screen and (max-width:$media-max-width){
      font-size: calc(8px + 1.87vw);
    }
  }
  .l-tx{
    color: #333333;
    font-size: 18px;
    font-family: 'GothamLight';
    font-weight: bold;
    @media screen and (max-width:$media-max-width){
      font-size: calc(8px + 1.5vw);
      display: -webkit-flex;
      display: flex;
      align-items: flex-start;
    }
    .cr{
      display: inline-block;
      border: 1px solid #b93848;
      padding: 3px;
      border-radius: 50%;
      vertical-align: middle;
      @media screen and (max-width:$media-max-width){
        margin-right: 5px;
        margin-top: 4px;
      }
    }
  }
  .r-tx{
    color: #333333;
    font-size: 18px;
    font-family: 'GothamLight';
    font-weight: bold;
    @media screen and (max-width:$media-max-width){
      font-size: calc(8px + 1.5vw);
    }
    .rs{
      color: #ba0c2f;
      font-weight: bold;
    }
  }
  .btnv2-close{
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    img{
      width: 53px;
      @media screen and (max-width:$media-max-width){
        width: 35px;
      }
    }
  }
  .line2{
    display: block;
    background: #ba0c2f;
    width: 50px;
    height: 2px;
    margin: 20px auto;
    @media screen and (max-width:$media-max-width){
      width: 35px;
      height: 1px;
    }
  }
  .link-list{
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/Popover/connactUS.vue